/* eslint-disable max-len */
import { ComponentPropsWithoutRef, memo } from 'react';

interface CloseIconProps extends ComponentPropsWithoutRef<'svg'> {
  fill?: string;
}

function CloseIcon({ fill = 'white', ...props }: CloseIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_4693_24362)">
        <path
          d="M8 8L2 2M8 8L2 14M8 8L14 2M8 8L14 14"
          stroke={fill}
          strokeWidth="2"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_4693_24362">
          <rect width="16" height="16" fill={fill} />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(CloseIcon);
